const REASON_TEXT: Record<string, string> = {
  never_started: 'The task was reserved for a worker that never started it',
  worker_gone: 'The worker stopped checking in while this task ran on it',
  unreported: 'The worker is alive but no longer lists this task as running; its finished report never arrived',
};

export default function workerLostReasonText(reason: string | null | undefined): string {
  return (reason && REASON_TEXT[reason]) || 'No worker appears to hold this task';
}
